import {
  OPEN_TRIAL_EXCEEDED_MODAL,
  CLOSE_TRIAL_EXCEEDED_MODAL,
  OPEN_TRIAL_LIMITATIONS_MODAL,
  CLOSE_TRIAL_LIMITATIONS_MODAL,
  OPEN_SUBSCRIPTION_UPGRADE_NEEDED,
  CLOSE_SUBSCRIPTION_UPGRADE_NEEDED,
  SET_STORE_CONFIGURATION_MODAL_VISIBILITY,
  SET_CREATOR_SEARCH_LOCKED_MODAL_VISIBILITY,
  SET_OUTSIDE_CLICK_WARNING_MODAL_VISIBILITY,
} from "./globalModalsTypes";

export interface GlobalModalsReducerState {
  trialExceededModalVisible: boolean;
  trialLimitationsModalVisible: boolean;
  subscriptionUpgradeNeededModalVisible: boolean;
  storeConfigurationModalVisible: boolean;
  creatorSearchLockedModalVisible: boolean;
  outsideClickWarningModalVisible: boolean;
}

const initialState: GlobalModalsReducerState = {
  trialExceededModalVisible: false,
  trialLimitationsModalVisible: false,
  subscriptionUpgradeNeededModalVisible: false,
  storeConfigurationModalVisible: false,
  creatorSearchLockedModalVisible: false,
  outsideClickWarningModalVisible: false,
};

// eslint-disable-next-line @typescript-eslint/default-param-last
function globalModalsReducer(state = initialState, action: any) {
  switch (action.type) {
    case OPEN_TRIAL_EXCEEDED_MODAL:
      return {
        ...state,
        trialExceededModalVisible: true,
      };

    case CLOSE_TRIAL_EXCEEDED_MODAL:
      return {
        ...state,
        trialExceededModalVisible: false,
      };
    case OPEN_TRIAL_LIMITATIONS_MODAL:
      return {
        ...state,
        trialLimitationsModalVisible: true,
      };

    case CLOSE_TRIAL_LIMITATIONS_MODAL:
      return {
        ...state,
        trialLimitationsModalVisible: false,
      };

    case OPEN_SUBSCRIPTION_UPGRADE_NEEDED:
      return {
        ...state,
        subscriptionUpgradeNeededModalVisible: true,
      };

    case CLOSE_SUBSCRIPTION_UPGRADE_NEEDED:
      return {
        ...state,
        subscriptionUpgradeNeededModalVisible: false,
      };

    case SET_STORE_CONFIGURATION_MODAL_VISIBILITY:
      return {
        ...state,
        storeConfigurationModalVisible:
          action.payload.storeConfigurationModalVisible,
      };

    case SET_CREATOR_SEARCH_LOCKED_MODAL_VISIBILITY:
      return {
        ...state,
        creatorSearchLockedModalVisible:
          action.payload.creatorSearchLockedModalVisible,
      };

    case SET_OUTSIDE_CLICK_WARNING_MODAL_VISIBILITY:
      return {
        ...state,
        outsideClickWarningModalVisible:
          action.payload.outsideClickWarningModalVisible,
      };

    default:
      return state;
  }
}

export default globalModalsReducer;
